import React,  {useState, useEffect} from "react";
import MDEditor from "@uiw/react-md-editor";
import { FetchWithAuth } from "./utils/FetchWithAuth";

export default function MarkdownPopupEditor({ isOpen, onClose, onSave, initialContent }) {
   const [value, setValue] = useState("");
const [loading, setLoading] = useState(false);
 const [saving, setSaving] = useState(false);
 const API_BASE = process.env.REACT_APP_API_BASE+"/admin";
 

  useEffect(() => {
    if (isOpen && initialContent) {
      setLoading(true);
      fetch(initialContent+"?t="+Date.now(), { cache: "no-store" }) // cache buster?t=${Date.now()}`, { cache: "no-store" }
        .then((res) => {
          if (!res.ok) throw new Error("Failed to load markdown file");
          return res.text();
        })
        .then((text) => setValue(text))
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    }
  }, [isOpen, initialContent]);

  const handleSave = async () => {
    setSaving(true);
    try {

        const response =  await FetchWithAuth(`${API_BASE}/update-md-file.php`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
          filePath: initialContent, // path of the file to update
          content: value,    // markdown content
        }),
            });

    

      if (!response.ok) throw new Error("Failed to save file");

     
      onClose();
    } catch (err) {
      console.error(err);
    
    } finally {
      setSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "8px",
          padding: "20px",
          width: "80%",
          maxWidth: "900px",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <h2 style={{ fontSize: "1.5rem", marginBottom: "10px" }}>Edit Markdown</h2>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <MDEditor value={value} onChange={setValue} height={400} />
        )}
        <div style={{ marginTop: "15px", textAlign: "right" }}>
          <button onClick={onClose} style={{ marginRight: "10px", backgroundColor:'gray' }}>
            Cancel
          </button>
          <button
            onClick={handleSave}
            disabled={saving}
            style={{
              marginLeft: "10px",
              background: "#007bff",
              color: "white",
              
              cursor: "pointer",
            }}
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
